import { types } from 'mobx-state-tree';

const VideoAssignmentSubmissionStatus = types.enumeration('VideoAssignmentSubmissionStatus', [
  'PENDING',
  'SUBMITTED',
  'COMPLETED',
  'FAILED',
]);

const Topic = types.model({
  startTime: types.number,
  endTime: types.number,
  title: types.string,
  summary: types.maybeNull(types.string),
});

const Analysis = types.model({
  recordingIssues: types.boolean,
  sideBySideCoverage: types.number,
  summary: types.string,
  topics: types.array(Topic),
  recordingQuality: types.maybeNull(types.string),
});

const Clip = types.model({
  path: types.string,
  thumbnail: types.maybeNull(types.string),
  ordinal: types.maybeNull(types.number),
});

const Video = types.model({
  id: types.string,
  createDate: types.string,
  duration: types.maybeNull(types.number),
  failed: types.maybeNull(types.boolean),
  clips: types.maybeNull(types.array(types.maybeNull(Clip))),
  thumbnails: types.maybeNull(types.array(types.maybeNull(types.string))),
  analysis: types.maybeNull(Analysis),
  status: types.maybeNull(VideoAssignmentSubmissionStatus),
});

const StatusHistory = types.model({
  event: types.string,
  videoId: types.string,
  createDate: types.string,
});

const VideoAssignmentSubmission = types.model({
  id: types.string,
  classId: types.number,
  createDate: types.string,
  assignmentId: types.string,
  objectType: types.string,
  status: VideoAssignmentSubmissionStatus,
  submittedVideoId: types.maybeNull(types.string),
  statusHistory: types.array(StatusHistory),
  videos: types.array(Video),
  userId: types.number,
  roomId: types.maybeNull(types.string),
  recordingStartedAt: types.maybeNull(types.number),
  recordingStoppedAt: types.maybeNull(types.number),
  submittedDate: types.maybeNull(types.string),
  assignedInstructorId: types.maybeNull(types.number),
});

export default VideoAssignmentSubmission;
